import { css } from "styled-components";

/** Shared visual tokens for line-table totals footers on detail pages. */
export const DETAIL_TOTALS_FOOTER_BG = "#eef2f7";
export const DETAIL_TOTALS_FOOTER_BORDER = "2px solid #c5d0e0";
export const DETAIL_TOTALS_FOOTER_SHADOW = "0 -6px 12px rgba(14, 14, 44, 0.1)";
export const DETAIL_TOTALS_FOOTER_HEIGHT = "48px";
export const DETAIL_TOTALS_LABEL_COLOR = "#4a4a68";
export const DETAIL_TOTALS_VALUE_COLOR = "#0e0e2c";

export const detailTotalsFooterRowCss = css`
  height: ${DETAIL_TOTALS_FOOTER_HEIGHT};
  font-size: 14px;
  font-weight: 600;
  background-color: ${DETAIL_TOTALS_FOOTER_BG};
  color: ${DETAIL_TOTALS_VALUE_COLOR};
`;

export const detailTotalsFooterCellCss = css`
  padding: 0 16px;
  background-color: ${DETAIL_TOTALS_FOOTER_BG};
  color: ${DETAIL_TOTALS_VALUE_COLOR};
`;

export const detailTotalsFooterStickyRowCss = css`
  position: sticky;
  bottom: 0;
  z-index: 2;
  box-shadow: ${DETAIL_TOTALS_FOOTER_SHADOW};
`;

export const detailTotalsFooterBarTopCss = css`
  border-top: ${DETAIL_TOTALS_FOOTER_BORDER};
`;

export const detailTotalsFooterLabelCss = css`
  font-weight: 700;
  font-size: 13px;
  color: ${DETAIL_TOTALS_LABEL_COLOR};
`;

export const detailTotalsFooterValueCss = css`
  font-weight: 700;
  font-size: 14px;
  font-variant-numeric: tabular-nums;
  color: ${DETAIL_TOTALS_VALUE_COLOR};
`;
